<template>
  <v-card>
    <profit-tabs></profit-tabs>
    <v-card-title v-show="false" class="secondary--text">{{ title }}</v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="2">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="wareLevels"
              v-model="filters.level"
              label="سطح کالا"
              @change="setFilterWithWareLevel"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
              class="rounded-lg"
              label="از کد "
              type="number"
              v-model="filters.code__gte"
          />
        </v-col>
        <v-col cols="12" md="2">

        <v-text-field
              class="rounded-lg"
              label="تا کد "
              type="number"
              v-model="filters.code__lte"
          />
        </v-col>

        </v-col>
        <v-col cols="12" md="3">
          <ware-select
              :multiple="true"
              :show-info="false"
              label="انتخاب کالا"
              :clearable="true"
              v-model="filtered_wares"
              type="wares"
              :show-main-unit="false"
              @change="setWareFilter()"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
              :menu-props="{ bottom: true, offsetY: true }"
              class="rounded-lg"
              :items="waresStatuses"
              v-model="filters.status"
              label="وضعیت کالا"
              @change="setFilterWithWareStatus"
          ></v-select>
        </v-col>
        <v-col cols="12" class="all-wares-inventory">
          <m-datatable :api-url="url" :headers="headers" :filters.sync="filters" ref="datatable"
                       :additional-applied-filters="appliedFilters">
            <template #item.gross_profit_margin_percent="{ item }">
              <span :class="(item.gross_profit_margin_percent >= 0)?'success_important--text':'danger--text'">
                {{ item.gross_profit_margin_percent }} %
              </span>
            </template>

          </m-datatable>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from "lodash";
import wareApiMixin from "@/mixin/wareApi";
import MDatatable from "@/components/m-datatable";
import OpenInventoryBtn from "@/components/btns/OpenInventoryBtn";
import SortInventory from "./SortInventory.vue";
import WarehouseSelect from "@/components/selects/WarehouseSelect.vue";
import ProfitTabs from "@/views/panel/inventory/ware/profitTabs";

export default {
  components: {ProfitTabs, MDatatable, OpenInventoryBtn, SortInventory, WarehouseSelect},
  mixins: [wareApiMixin],
  data() {
    return {
      filter_warehouses: [0],
      filtered_wares: [],
      filtered_ware: null,
      appliedFilters: [],

      url: "reports/wareProfitReport",
      headers: [
        {
          text: "کد کالا",
          value: "code",
          sortable: false,
        },
        {
          text: "نام کالا",
          value: "name",
          sortable: false,
        },
        {
          text: "فروش خالص",
          value: "net_sales",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "بهای تمام شده کالای فروش رفته",
          value: "cost_value",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "سود ناخالص",
          value: "gross_profit",
          type: "numeric",
          sortable: false,
          filterable: false,
        },
        {
          text: "درصد حاشیه سود ناخالص",
          value: "gross_profit_margin_percent",
          sortable: false,
          filterable: false,
        },
      ],
      filters: {
        level: 3,
      },
    };
  },
  created() {
    this.getWarehouses();
  },
  mounted() {
    this.setFilterWithWareLevel()
  },

  methods: {
    setFilterWithWarehouses() {
      this.setWarehouseAppliedFilter(this.filter_warehouses)
      let warehouses_string = this.filter_warehouses.join(",");
      if (warehouses_string != "0") {
        this.filters.warehouse_in = warehouses_string;
      } else {
        this.filters.warehouse_in = undefined;
      }
      this.$refs.datatable.getDataFromApi();
    },
    warehouseName(id) {
      if (id == 0) {
        return 'همه انبار ها'
      }
      for (let warehouse of this.warehouses) {
        if (warehouse.id == id) {
          return warehouse.title
        }
      }
    },
    setFilterWithWareLevel() {
      let filter_set_done = false
      for (let filter of this.appliedFilters) {
        if (filter.text == 'سطح کالا  ') {
          filter.value = this.wareLevelName(this.filters.level)
          filter_set_done = true
        }
      }
      if (!filter_set_done) {
        this.appliedFilters.push(
            {
              text: 'سطح کالا  ',
              typeText: null,
              value: this.wareLevelName(this.filters.level)
            }
        )
      }

    },
    wareLevelName(value) {
      for (let wareLevel of this.wareLevels) {
        if (wareLevel.value == value) {
          return wareLevel.text
        }
      }
    },
    setWareFilter() {
      let filter_wares_string = ''
      this.filtered_wares.forEach(function (obj) {
        filter_wares_string += obj.id
        filter_wares_string += ','
      })
      filter_wares_string = filter_wares_string.slice(0, -1)
      this.filters.id__in = filter_wares_string
      this.$refs.datatable.getDataFromApi()
    },
    setFilterWithWareStatus() {
      let filter_set_done = false
      for (let filter of this.appliedFilters) {
        if (filter.text == 'وضعیت کالا  ') {
          filter.value = this.wareStatusName(this.filters.status)
          filter_set_done = true
        }
      }
      if (!filter_set_done) {
        this.appliedFilters.push(
            {
              text: 'وضعیت کالا  ',
              typeText: null,
              value: this.wareStatusName(this.filters.status)
            }
        )
      }

    },
    wareStatusName(value) {
      for (let waresStatus of this.waresStatuses) {
        if (waresStatus.value == value) {
          return waresStatus.text
        }
      }
    },
    setWarehouseAppliedFilter(filteredWarehouses) {
      let value_string = ''
      let filter_set_done = false
      for (let warehouse of filteredWarehouses) {
        value_string += this.warehouseName(warehouse)
      }
      for (let filter of this.appliedFilters) {
        if (filter.text == 'انبار  ') {
          filter.value = value_string
          filter_set_done = true
        }
      }
      if (!filter_set_done) {
        this.appliedFilters.push(
            {
              text: 'انبار  ',
              typeText: null,
              value: value_string,
            }
        )
      }

    },
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش سود کالا')
    },
  }
};
</script>

<style lang="scss">
</style>
